module.exports = __webpack_public_path__ + "2020celebration/img/p2.f424ccaa.png";